import React from 'react';
import PropTypes from 'prop-types';
import { isValid } from '@fnando/cnpj';
import { BaseInput, BaseNumberFormat } from '../BaseInput';

const CNPJ_SIZE = 14;

const NumberFormat = (props) => (
  <BaseNumberFormat
    format="##.###.###/####-##"
    mask="_"
    isAllowed={({ value }) => value.length <= CNPJ_SIZE}
    {...props}
  />
);

NumberFormat.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

const CnpjInput = (props) => (
  <BaseInput inputComponent={NumberFormat} isValid={isValid} {...props} />
);

CnpjInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  onBlur: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  inputIsInvalid: PropTypes.bool,
};

CnpjInput.defaultProps = {
  errorMessage: 'CNPJ inválido',
  onBlur: () => {},
  label: 'CNPJ',
  placeholder: '',
  disabled: false,
  required: false,
  inputIsInvalid: false,
};

export default CnpjInput;
